import React from 'react';

import { Widget } from '../../_lib/components/Widget';
import { Widget as WidgetShape } from '../../types/api/Widget';
import { UserAccountBlock } from '../../_blocks/UserAccount';
import { WidgetType } from '../../types/api/ElementType';

export type UserAccountWidget = WidgetShape<[UserAccountBlock], WidgetType.useraccount>;

export function UserAccountWidget({ blocks, uuid, elementType }: UserAccountWidget) {
  return (
    <Widget uuid={uuid} widgetType={elementType}>
      <UserAccountBlock {...blocks[0]} />
    </Widget>
  );
}
